module.exports = __webpack_public_path__ + "img/Icon_Auto.34c41463.png";